export enum RouteName {
  list = 'pay-by-link-list',
  id = 'pay-by-link-list-id',
  create = 'payment-link-create',
}
